module.exports = __webpack_public_path__ + "./images/9f78e8c2fc23b50548c7f3239db274cd.webp";